var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCheckMonogram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1607 5.58539C19.0245 13.6178 15.735 18.7013 9.82176 19.9492L9.57846 20L9.3371 19.9473C3.15329 18.6251 -0.159536 13.0925 0.00591039 4.36676L0.0136961 3.86876L0.377679 3.53091C2.81072 1.2655 6.06904 0.0117176 9.55315 0H9.60181C11.7312 0 13.773 0.464798 15.5949 1.34752C15.7175 1.40807 15.7409 1.57407 15.6416 1.66781L14.1623 3.04072C14.0533 3.14227 13.8976 3.16961 13.7594 3.11688C9.99889 1.68148 5.46176 2.28298 2.33773 4.92335C2.32606 10.0498 3.62822 16.1742 9.5843 17.6037C12.5876 16.8909 15.9608 14.5611 16.6868 7.88204C16.7511 7.30007 16.7939 6.68489 16.8153 6.03457L19.1491 3.87072L19.1588 4.36676C19.1685 4.78078 19.1685 5.18699 19.1627 5.58735L19.1607 5.58539Z",
    fill: "#99C3D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1474 3.86879L16.8136 6.03264L8.97535 13.3015C8.82158 13.444 8.58412 13.4382 8.43619 13.2917L4.76133 9.60456C4.60951 9.45223 4.60951 9.20421 4.76133 9.05188L6.13551 7.67115C6.28733 7.51883 6.53453 7.51883 6.68635 7.67115L8.77487 9.7647L15.2098 3.79653L16.7728 2.34746C16.9051 2.22442 17.1036 2.20684 17.2535 2.3084C17.7927 2.67555 18.3046 3.08566 18.7873 3.53484L19.1474 3.87074V3.86879Z",
    fill: "#99C3D1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M19.1609 5.5854L16.6851 7.8801C16.7493 7.29813 16.7921 6.68295 16.8135 6.03263L19.1473 3.86877L19.157 4.36482C19.1668 4.77884 19.1668 5.18505 19.1609 5.5854Z",
    fill: "#3487A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckMonogram);
export default __webpack_public_path__ + "static/media/IconCheckMonogram.e613d50397555a7bba6e033cba7c8837.svg";
export { ForwardRef as ReactComponent };